import './checkbox.scss';

export type CheckboxProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
};

const Checkbox = ({ label, checked, onChange, disabled = false, className }: CheckboxProps) => {
    return (
        <label className={`checkbox ${className ?? ''} ${disabled ? 'checkbox--disabled' : ''}`}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span className="checkbox__label">{label}</span>
        </label>
    );
};

export default Checkbox;
